import React from 'react';
import styles from './styles/AdminTopBar.module.css';

const AdminTopBar = ({ activeTab, setActiveTab }) => {
    const tabs = [
        { name: 'Scenarios', label: 'Scenarios' },
        { name: 'Tags', label: 'Tags' },
        { name: 'Site Feedback', label: 'Feedback' },
        { name: 'Users', label: 'User Management' },
        { name: 'Statistics', label: 'Statistics' }
    ];

    return (
        <div className={styles.topBarContainer}>
            <nav className={styles.nav}>
                {tabs.map((tab) => (
                    <button 
                        key={tab.name}
                        onClick={() => setActiveTab(tab.name)}
                        className={`
                            ${styles.navBtn} 
                            ${activeTab === tab.name ? styles.active : ''}
                        `}
                    >
                        {tab.label}
                        {activeTab === tab.name && <span className={styles.activeIndicator} />}
                    </button>
                ))}
            </nav>
        </div>
    );
};

export default AdminTopBar;